/**
 * 签到服务
 * 处理用户每日签到相关的 API 调用
 */

import apiClient from "@/lib/apiClient";

/**
 * 签到响应类型
 */
export interface CheckInResponse {
  points: number;
  checked_in_today: boolean;
  message?: string;
}

/**
 * 签到服务
 */
export const checkInService = {
  /**
   * 执行签到
   * @returns 签到结果，包含获得的积分
   */
  checkIn: () =>
    apiClient<CheckInResponse>("/check_ins.json", {
      method: "POST",
      disableAutoToast: true,
    }),
};

export default checkInService;
